/* src/app/private/components/view/counter/counter.component.scss */
label {
  font-weight: 500;
  font-size: 1.2rem;
}
/*# sourceMappingURL=counter.component.css.map */
